import { EMenuKeys, PRODUCT_STUBSTEP_KEYS } from 'core/common/constants/product-new'
import i18n from 'core/common/i18n'
import { AnatelCertificationForm } from 'core/containers/AnatelCertificationForm'
import {
  FirstVariationType,
  FirstVariationValue,
  SecondVariationType,
  SecondVariationValue,
  ThirdVariationType,
  ThirdVariationValue,
} from 'core/containers/MultiVariation'
import { ProductBasicDataForm } from 'core/containers/ProductBasicDataForm'
import { ProductCharacteristicsForm } from 'core/containers/ProductCharacteristicsForm'
import { ProductDatasheetForm } from 'core/containers/ProductDatasheetForm'
import ProductDescriptionForm from 'core/containers/ProductDescriptionForm'
import ProductFreightV2 from 'core/containers/ProductFreight/ProductFreightV2'
import { ProductPriceForm } from 'core/containers/ProductPriceForm'
import ProductPublish from 'core/containers/ProductPublish'
import ProductStockForm from 'core/containers/ProductStockForm'
// import ProductTaxDataForm from 'core/containers/ProductTaxDataForm'
import { ProductVariationDetailsForm } from 'core/containers/ProductVariationForm'
import { RegulatoryInformationForm } from 'core/containers/RegulatoryInformationForm'
import { TStoreConfigStep } from './types'

export const PRODUCT_NEW_STEPS_SIMPLE: TStoreConfigStep[] = [
  {
    title: i18n.t<string>('productNew.menu.basicData'),
    key: `${EMenuKeys.BASIC_DATA}-0`,
    subSteps: [
      {
        key: PRODUCT_STUBSTEP_KEYS.PRODUCT_BASIC_DATA,
        component: ProductBasicDataForm,
      },
      {
        key: PRODUCT_STUBSTEP_KEYS.PRODUCT_CHARACTERISTICS,
        component: ProductCharacteristicsForm,
      },
      {
        key: PRODUCT_STUBSTEP_KEYS.REGULATORY_INFO,
        component: RegulatoryInformationForm,
      },
      {
        key: PRODUCT_STUBSTEP_KEYS.ANATEL_CERTIFICATION,
        component: AnatelCertificationForm,
      },
      {
        key: PRODUCT_STUBSTEP_KEYS.PRODUCT_VARIATION_DETAILS,
        component: ProductVariationDetailsForm,
      },
    ],
  },
  {
    title: i18n.t<string>('productNew.menu.datasheet'),
    key: `${EMenuKeys.DATASHEET}-0`,
    subSteps: [
      {
        key: `${EMenuKeys.DATASHEET}-1`,
        component: ProductDatasheetForm,
      },
    ],
  },
  // {
  //   title: i18n.t<string>('productNew.menu.taxData'),
  //   key: `${EMenuKeys.TAX_DATA}-0`,
  //   subSteps: [
  //     {
  //       key: `${EMenuKeys.TAX_DATA}-1`,
  //       component: ProductTaxDataForm,
  //     },
  //   ],
  // },
  {
    title: i18n.t<string>('productNew.menu.shippingDetails'),
    key: `${EMenuKeys.SHIPPING_DETAILS}-0`,
    subSteps: [
      {
        key: `${EMenuKeys.SHIPPING_DETAILS}-1`,
        component: ProductFreightV2,
      },
    ],
  },
  {
    title: i18n.t<string>('productNew.menu.publication'),
    key: `${EMenuKeys.PUBLICATION}-0`,
    subSteps: [
      {
        key: `${EMenuKeys.PUBLICATION}-1`,
        component: ProductPriceForm,
      },
      {
        key: `${EMenuKeys.PUBLICATION}-2`,
        component: ProductStockForm,
      },
      {
        key: `${EMenuKeys.PUBLICATION}-3`,
        component: ProductDescriptionForm,
      },
      {
        key: `${EMenuKeys.PUBLICATION}-4`,
        component: ProductPublish,
      },
    ],
  },
]

export const PRODUCT_NEW_STEPS_VARIATIONS: TStoreConfigStep[] = [
  {
    title: i18n.t<string>('productNew.menu.basicData'),
    key: `${EMenuKeys.BASIC_DATA}-0`,
    subSteps: [
      {
        key: PRODUCT_STUBSTEP_KEYS.PRODUCT_BASIC_DATA,
        title: 'Título da oferta',
        component: ProductBasicDataForm,
        editable: true,
      },
      {
        key: PRODUCT_STUBSTEP_KEYS.PRODUCT_CHARACTERISTICS,
        title: 'Características',
        component: ProductCharacteristicsForm,
        editable: true,
      },
      {
        key: PRODUCT_STUBSTEP_KEYS.REGULATORY_INFO,
        title: 'Informações regulatórias',
        component: RegulatoryInformationForm,
        editable: true,
      },
      {
        key: PRODUCT_STUBSTEP_KEYS.ANATEL_CERTIFICATION,
        title: 'Certificação e registro da Anatel',
        component: AnatelCertificationForm,
        editable: true,
      },
      {
        key: PRODUCT_STUBSTEP_KEYS.FIRST_VARIATION_TYPE,
        component: FirstVariationType,
      },
      {
        key: PRODUCT_STUBSTEP_KEYS.FIRST_VARIATION_VALUE,
        component: FirstVariationValue,
      },
      {
        key: PRODUCT_STUBSTEP_KEYS.SECOND_VARIATION_TYPE,
        component: SecondVariationType,
      },
      {
        key: PRODUCT_STUBSTEP_KEYS.SECOND_VARIATION_VALUE,
        component: SecondVariationValue,
      },
      {
        key: PRODUCT_STUBSTEP_KEYS.THIRD_VARIATION_TYPE,
        component: ThirdVariationType,
      },
      {
        key: PRODUCT_STUBSTEP_KEYS.THIRD_VARIATION_VALUE,
        component: ThirdVariationValue,
      },
      {
        key: PRODUCT_STUBSTEP_KEYS.PRODUCT_VARIATION_DETAILS,
        title: 'Variações e fotos',
        component: ProductVariationDetailsForm,
        editable: true,
      },
    ],
  },
  {
    title: i18n.t<string>('productNew.menu.datasheet'),
    key: `${EMenuKeys.DATASHEET}-0`,
    subSteps: [
      {
        key: `${EMenuKeys.DATASHEET}-1`,
        title: 'Ficha técnica',
        component: ProductDatasheetForm,
        editable: true,
      },
    ],
  },
  // {
  //   title: i18n.t<string>('productNew.menu.taxData'),
  //   key: `${EMenuKeys.TAX_DATA}-0`,
  //   subSteps: [
  //     {
  //       key: `${EMenuKeys.TAX_DATA}-1`,
  //       title: 'Dados fiscais',
  //       component: ProductTaxDataForm,
  //       editable: true,
  //     },
  //   ],
  // },
  {
    title: i18n.t<string>('productNew.menu.shippingDetails'),
    key: `${EMenuKeys.SHIPPING_DETAILS}-0`,
    subSteps: [
      {
        key: `${EMenuKeys.SHIPPING_DETAILS}-1`,
        title: 'Peso e dimensões do produto embalado',
        component: ProductFreightV2,
        editable: true,
      },
    ],
  },
  {
    title: i18n.t<string>('productNew.menu.publication'),
    key: `${EMenuKeys.PUBLICATION}-0`,
    subSteps: [
      {
        key: `${EMenuKeys.PUBLICATION}-1`,
        title: 'Preço',
        component: ProductPriceForm,
        editable: true,
      },
      {
        key: `${EMenuKeys.PUBLICATION}-2`,
        title: 'Estoque',
        component: ProductStockForm,
        editable: true,
      },
      {
        key: `${EMenuKeys.PUBLICATION}-3`,
        title: 'Descrição',
        component: ProductDescriptionForm,
        editable: true,
      },
      {
        key: `${EMenuKeys.PUBLICATION}-4`,
        component: ProductPublish,
      },
    ],
  },
]

export const PRODUCT_NEW_STEPS_TELECOM: TStoreConfigStep[] = [
  {
    title: i18n.t<string>('productNew.menu.basicData'),
    key: `${EMenuKeys.BASIC_DATA}-0`,
    subSteps: [
      {
        key: PRODUCT_STUBSTEP_KEYS.PRODUCT_BASIC_DATA,
        component: ProductBasicDataForm,
      },
      {
        key: PRODUCT_STUBSTEP_KEYS.PRODUCT_CHARACTERISTICS,
        component: ProductCharacteristicsForm,
      },
      {
        key: PRODUCT_STUBSTEP_KEYS.REGULATORY_INFO,
        component: RegulatoryInformationForm,
      },
      {
        key: PRODUCT_STUBSTEP_KEYS.ANATEL_CERTIFICATION,
        component: AnatelCertificationForm,
      },
      {
        key: PRODUCT_STUBSTEP_KEYS.FIRST_VARIATION_TYPE,
        component: FirstVariationType,
      },
      {
        key: PRODUCT_STUBSTEP_KEYS.FIRST_VARIATION_VALUE,
        component: FirstVariationValue,
      },
      {
        key: PRODUCT_STUBSTEP_KEYS.SECOND_VARIATION_TYPE,
        component: SecondVariationType,
      },
      {
        key: PRODUCT_STUBSTEP_KEYS.SECOND_VARIATION_VALUE,
        component: SecondVariationValue,
      },
      {
        key: PRODUCT_STUBSTEP_KEYS.THIRD_VARIATION_TYPE,
        component: ThirdVariationType,
      },
      {
        key: PRODUCT_STUBSTEP_KEYS.THIRD_VARIATION_VALUE,
        component: ThirdVariationValue,
      },
      {
        key: PRODUCT_STUBSTEP_KEYS.PRODUCT_VARIATION_DETAILS,
        component: ProductVariationDetailsForm,
      },
    ],
  },
  {
    title: i18n.t<string>('productNew.menu.datasheet'),
    key: `${EMenuKeys.DATASHEET}-0`,
    subSteps: [
      {
        key: `${EMenuKeys.DATASHEET}-1`,
        component: ProductDatasheetForm,
      },
    ],
  },
  // {
  //   title: i18n.t<string>('productNew.menu.taxData'),
  //   key: `${EMenuKeys.TAX_DATA}-0`,
  //   subSteps: [
  //     {
  //       key: `${EMenuKeys.TAX_DATA}-1`,
  //       component: ProductTaxDataForm,
  //     },
  //   ],
  // },
  {
    title: i18n.t<string>('productNew.menu.shippingDetails'),
    key: `${EMenuKeys.SHIPPING_DETAILS}-0`,
    subSteps: [
      {
        key: `${EMenuKeys.SHIPPING_DETAILS}-1`,
        component: ProductFreightV2,
      },
    ],
  },
  {
    title: i18n.t<string>('productNew.menu.publication'),
    key: `${EMenuKeys.PUBLICATION}-0`,
    subSteps: [
      {
        key: `${EMenuKeys.PUBLICATION}-1`,
        component: ProductPriceForm,
      },
      {
        key: `${EMenuKeys.PUBLICATION}-2`,
        component: ProductStockForm,
      },
      {
        key: `${EMenuKeys.PUBLICATION}-3`,
        component: ProductDescriptionForm,
      },
      {
        key: `${EMenuKeys.PUBLICATION}-4`,
        component: ProductPublish,
      },
    ],
  },
]

export const PRODUCT_NEW_STEPS_BOOK: TStoreConfigStep[] = [
  {
    title: i18n.t<string>('productNew.menu.basicData'),
    key: `${EMenuKeys.BASIC_DATA}-0`,
    subSteps: [
      {
        key: PRODUCT_STUBSTEP_KEYS.PRODUCT_BASIC_DATA,
        component: ProductBasicDataForm,
      },
      {
        key: PRODUCT_STUBSTEP_KEYS.PRODUCT_CHARACTERISTICS,
        component: ProductCharacteristicsForm,
      },
      {
        key: PRODUCT_STUBSTEP_KEYS.REGULATORY_INFO,
        component: RegulatoryInformationForm,
      },
      {
        key: PRODUCT_STUBSTEP_KEYS.FIRST_VARIATION_TYPE,
        component: FirstVariationType,
      },
      {
        key: PRODUCT_STUBSTEP_KEYS.FIRST_VARIATION_VALUE,
        component: FirstVariationValue,
      },
      {
        key: PRODUCT_STUBSTEP_KEYS.SECOND_VARIATION_TYPE,
        component: SecondVariationType,
      },
      {
        key: PRODUCT_STUBSTEP_KEYS.SECOND_VARIATION_VALUE,
        component: SecondVariationValue,
      },
      {
        key: PRODUCT_STUBSTEP_KEYS.THIRD_VARIATION_TYPE,
        component: ThirdVariationType,
      },
      {
        key: PRODUCT_STUBSTEP_KEYS.THIRD_VARIATION_VALUE,
        component: ThirdVariationValue,
      },
      {
        key: PRODUCT_STUBSTEP_KEYS.PRODUCT_VARIATION_DETAILS,
        component: ProductVariationDetailsForm,
      },
    ],
  },
  {
    title: i18n.t<string>('productNew.menu.datasheet'),
    key: `${EMenuKeys.DATASHEET}-0`,
    subSteps: [
      {
        key: `${EMenuKeys.DATASHEET}-1`,
        component: ProductDatasheetForm,
      },
    ],
  },
  // {
  //   title: i18n.t<string>('productNew.menu.taxData'),
  //   key: `${EMenuKeys.TAX_DATA}-0`,
  //   subSteps: [
  //     {
  //       key: `${EMenuKeys.TAX_DATA}-1`,
  //       component: ProductTaxDataForm,
  //     },
  //   ],
  // },
  {
    title: i18n.t<string>('productNew.menu.shippingDetails'),
    key: `${EMenuKeys.SHIPPING_DETAILS}-0`,
    subSteps: [
      {
        key: `${EMenuKeys.SHIPPING_DETAILS}-1`,
        component: ProductFreightV2,
      },
    ],
  },
  {
    title: i18n.t<string>('productNew.menu.publication'),
    key: `${EMenuKeys.PUBLICATION}-0`,
    subSteps: [
      {
        key: `${EMenuKeys.PUBLICATION}-1`,
        component: ProductPriceForm,
      },
      {
        key: `${EMenuKeys.PUBLICATION}-2`,
        component: ProductStockForm,
      },
      {
        key: `${EMenuKeys.PUBLICATION}-3`,
        component: ProductDescriptionForm,
      },
      {
        key: `${EMenuKeys.PUBLICATION}-4`,
        component: ProductPublish,
      },
    ],
  },
]

export const PRODUCT_NEW_STEPS_FLOW = {
  simple: PRODUCT_NEW_STEPS_SIMPLE,
  variations: PRODUCT_NEW_STEPS_VARIATIONS,
  telecom: PRODUCT_NEW_STEPS_TELECOM,
  book: PRODUCT_NEW_STEPS_BOOK,
}

export const defaultValues = {
  variations: [],
  linkedProducts: [],
  channels: ['magazineluiza'],
  prices: [],
  stocks: [],
  isPriceVariable: true,
  uploadedImages: [],
  genre: 'outros',
  brand: '',
  video: '',
  searchVideo: '',
  isVariationEnabled: false,
  datasheet: [],
  name: '',
  ean: '',
  ncm: '',
  sku: '',
  type: '',
  isbn: '',
  description: '',
  origin: 'national',
  delivered: true,
  perishable: false,
  fulfillment: false,
  package: {
    standard_packing: false,
    height: 0,
    depth: 0,
    size: '',
    unit: 'cm',
    weight: { value: 0, unit: 'g' },
    width: 0,
  },
  tax_replacement: false,
  anatel: '',
  anvisa: '',
  mapa: '',
  selectedAttributes: {},
}
